import * as React from 'react';

const TrashIcon = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='22'
      viewBox='0 0 16 22'
      fill='none'
      {...props}
    >
      <path
        d='M12.025 19.0583C12.0167 19.1667 11.925 19.25 11.8167 19.25H4.175C4.06667 19.25 3.975 19.1667 3.96667 19.0583L2.75 6.5H0.5L1.73333 19.275C1.85833 20.5417 2.90833 21.5 4.18333 21.5H11.825C13.0917 21.5 14.1417 20.5417 14.2583 19.275L15.4917 6.5H13.2417L12.025 19.0583Z'
        fill='var(--colorIconPrimary)'
      />
      <path
        d='M9.125 2.75V0.5L6.875 1.25V2.75H0.5V5H15.5V2.75H9.125Z'
        fill='var(--colorIconPrimary)'
      />
      <path d='M7.25 6.5H5V17.75H7.25V6.5Z' fill='var(--colorIconPrimary)' />
      <path d='M11 6.5H8.75V17.75H11V6.5Z' fill='var(--colorIconPrimary)' />
    </svg>
  );
};
export default TrashIcon;
